<template>
  <b-modal
      ref="show-campaign-modal"
      :title="$t('campaign.details.modal')"
      :cancel-title="$t('btn.close')"
      ok-only
      size="lg"
  >
    <div v-if="campaign" class="question-details">
      <div class="row">
        <div class="col-12">
          <table class="table">
            <tr>
              <th>{{ $t('campaign.details.id') }}</th>
              <td>{{ campaign.id }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.name') }}</th>
              <td>{{ campaign.name }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.title') }}</th>
              <td>{{ campaign.title }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.content') }}</th>
              <td v-html="campaign.content"></td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.senders_email') }}</th>
              <td>{{ campaign.sendersEmail}}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.senders_name') }}</th>
              <td>{{ campaign.sendersName}}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.createdAt') }}</th>
              <td>{{ campaign.createdAt | dateTime24HoursFormat }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.sendingTime') }}</th>
              <td>{{ campaign.sendingTime | dateTime24HoursFormat }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.sentDate') }}</th>
              <td>{{ campaign.sentDate | dateTime24HoursFormat }}</td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.status') }}</th>
              <td>
                <b-badge pill variant="primary" v-if="campaign.status === 'draft'">{{ $t('campaign_status_' + campaign.status ) }}</b-badge>
                <b-badge pill variant="success" v-if="campaign.status === 'active'">{{ $t('campaign_status_' + campaign.status ) }}</b-badge>
              </td>
            </tr>
            <tr>
              <th>{{ $t('campaign.details.segments') }}</th>
              <td>
                <div v-for="segment in campaign.segments" :key="segment.id">
                  {{ segment.name }}
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
// import moment from 'moment';

export default {
  data() {
    return {
      campaign: null
    }
  },
  filters: {},
  mounted() {

  },
  methods: {
    openModal(campaign) {
      this.campaign = campaign;
      this.$refs['show-campaign-modal'].show();
    }
  }
}
</script>
